import React, { useState } from 'react';
import ItemTypeManagement from "../ItemManage/ItemTypeManagement";
import SubProductItemManagement from "../ItemManage/SubProductItemManagement";
import SalePriceListManagement from "../SalePriceManage/SalePriceListManagement";

const SalePriceAndItemManage = () => {
    const [activeTab, setActiveTab] = useState('main'); // 'main' or 'sub'

    return (
        <div className="sale-price-and-item-manage">
            <div className="btc-topbar" style={{ marginBottom: '1rem' }}>
                <button 
                    className={`btc-topbar-tab ${activeTab === 'main' ? 'active' : ''}`}
                    onClick={() => setActiveTab('main')}
                >
                    สินค้าหลัก (Main Products)
                </button>
                <button 
                    className={`btc-topbar-tab ${activeTab === 'sub' ? 'active' : ''}`}
                    onClick={() => setActiveTab('sub')}
                >
                    สินค้าเสริม (Sub Products)
                </button>
            </div>
            
            <h1>จัดการสินค้าและราคาขาย</h1>
            <div style={{display: 'grid', gap: '2rem'}}>
                <section>
                    {activeTab === 'main' ? (
                        <>
                            <ItemTypeManagement />
                            <SalePriceListManagement />
                        </>
                    ) : (
                        <SubProductItemManagement />
                    )}
                </section>
            </div>
        </div>
    );
};

export default SalePriceAndItemManage;
